import React from 'react';

// ── What to show while a page is still on its way ───────────────────────────
// Public pages arrive prerendered (scripts/prerender.mjs), so the visitor is
// already looking at the page when the bundle runs. createRoot then clears it
// on the first commit, and until the route's chunk and its data have arrived
// the screen used to be white with a spinner: the page, then a blank, then
// the page again (owner, 10 Oct 2026, on /parts/my-day: "glitching and
// flickering"). main.jsx keeps a copy of what was on screen; this draws it
// back, pixel for pixel, for the address it was made for. Any other address
// (a navigation inside the app) gets the spinner as before.

export function prerenderedFor(pathname) {
  if (typeof window === 'undefined') return null;
  const pre = window.__prerendered;
  return pre?.html && pre.path === pathname ? pre.html : null;
}

export default function PrerenderedFallback() {
  const html = prerenderedFor(typeof window !== 'undefined' ? window.location.pathname : '');
  if (html) return <div data-prerendered="" dangerouslySetInnerHTML={{ __html: html }} />;
  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-slate-300 border-t-slate-600" />
    </div>
  );
}
